import React from 'react';
import { DataProvider } from './GridDataAdaptor';
import { FilterCriteria } from 'patients-experience-client';
import { ColDef } from 'ag-grid-community';

interface ExportDataButtonProps {
  colDefs: ColDef[];
  dataProvider: DataProvider;
  filters: FilterCriteria[];
}

const ExportDataButton: React.FC<ExportDataButtonProps> = ({
  colDefs,
  dataProvider,
  filters,
}) => {
  const getAllRows = async (): Promise<any[]> => {
    const allRows: any[] = [];
    let startRow = 0;
    const blockSize = 100;

    while (true) {
      const request = {
        filters: filters ?? [],
        sortCriteria: [],
        startRow: startRow,
        endRow: startRow + blockSize,
      };

      const response = await dataProvider?.(request);

      if (response && response.data.length > 0) {
        allRows.push(...response.data);
        startRow += blockSize;
      } else {
        break;
      }
    }

    return allRows;
  };

  const exportAllDataToCsv = async () => {
    const allRows = await getAllRows();

    const columnDefs = colDefs;
    const headers = columnDefs?.map((colDef: any) => colDef.headerName || colDef.field) || [];
    const fields = columnDefs?.map((colDef: any) => colDef.field) || [];

    const csvContent = [
      headers.join(','),
      ...allRows.map((row) =>
        fields.map((field) => {
          const value = row[field!];
          return typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value;
        }).join(',')
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'export.csv';
    link.click();
    URL.revokeObjectURL(link.href);
  };

  return (
    <div>
        <button className="btn btn-sm btn-secondary ms-2 px-4 py-md-2 rounded-pill" onClick={exportAllDataToCsv}>
          Export Data
        </button>
    </div>
  );
};

export default ExportDataButton;
